import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import * as sharedActions from '@/shared/Actions';

import Button from '@/components/button/Button';
import Tooltip from '@/components/tooltip/Tooltip';

import type { UserSettings } from '@/shared/types';

type AudioToggleButtonProps = {
	audioOn: boolean;
	tooltip: string;
	className?: string;
	isOpen?: boolean;
	hiddenTooltip?: boolean;
	small?: boolean;
	onToggle?: (nextAudioOn: boolean) => void;
	updateUserDataRequest: (data: Partial<UserSettings>) => void;
};

const AudioToggleButton = ({
	audioOn,
	tooltip,
	className,
	isOpen,
	hiddenTooltip,
	small,
	onToggle,
	updateUserDataRequest,
}: AudioToggleButtonProps) => {
	const handleToggle = useCallback(() => {
		const nextAudioOn = !audioOn;
		updateUserDataRequest({ audio_on: nextAudioOn });
		onToggle?.(nextAudioOn);
	}, [audioOn, onToggle, updateUserDataRequest]);

	return (
		<Tooltip
			place="bottom"
			title={tooltip}
			className="audio-toggle-button__tooltip"
			isOpen={isOpen}
			hidden={hiddenTooltip}
		>
			<Button
				iconName={audioOn ? 'icon-music-on' : 'icon-music-off'}
				color="white"
				type="secondary"
				rounded
				small={small}
				onClick={handleToggle}
				className={classNames('audio-toggle-button', className)}
			/>
		</Tooltip>
	);
};

function mapStateToProps({ sharedReducer }: any) {
	const settings: UserSettings = sharedReducer?.userData?.settings ?? {};
	return {
		audioOn: settings.audio_on ?? true,
	};
}

const mapDispatchToProps = {
	updateUserDataRequest: sharedActions.updateUserDataRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(AudioToggleButton);
